import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
} from '@mui/material';

const ShareRegistrationPage = () => {
    const [isTokenValid, setIsTokenValid] = useState(false);
const [searchParams] = useSearchParams();
const regId = searchParams.get('regId');
const token = searchParams.get('token');
  const [formData, setFormData] = useState({
    sendSMS: false,
    registrationCode: '',
    registrationDate: new Date().toISOString().split('T')[0],
    candidateName: '',
    gender: '',
    mobileNo: '',
    email: '',
    dateOfBirth: '',
    country: '',
    state: '',
    city: '',
    address: '',
    nationality: '',
    registrationFee: '',
    course: '',
  });

  const staticGenderData = [
    { id: 1, name: 'Male' },
    { id: 2, name: 'Female' },
    { id: 3, name: 'Other' },
  ];

  const staticCountryData = [
    { id: 1, name: 'India' },
    { id: 2, name: 'USA' },
    { id: 3, name: 'UK' },
  ];

  const staticStateData = [
    { id: 1, name: 'State 1' },
    { id: 2, name: 'State 2' },
    { id: 3, name: 'State 3' },
  ];

  const staticCityData = [
    { id: 1, name: 'City 1' },
    { id: 2, name: 'City 2' },
    { id: 3, name: 'City 3' },
  ];

  const staticNationalityData = [
    { id: 1, name: 'Indian' },
    { id: 2, name: 'American' },
    { id: 3, name: 'British' },
  ];

  const staticCourseData = [
    { id: 1, name: 'Computer Science' },
    { id: 2, name: 'Mathematics' },
    { id: 3, name: 'Physics' },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  useEffect(() => {
  if (token) {
    let tokens = {};
    const storedTokens = localStorage.getItem('registrationTokens');
    if (storedTokens && storedTokens !== 'undefined') {
      try {
        tokens = JSON.parse(storedTokens);
      } catch (err) {
        console.warn('Invalid registrationTokens in localStorage:', err, storedTokens);
      }
    }
    if (tokens[token] && !tokens[token].used) {
      setIsTokenValid(true);
    } else {
      setIsTokenValid(false);
    }
  } else {
    setIsTokenValid(false);
  }
}, [token]);

  const handleSubmit = () => {
  if (
    formData.registrationCode &&
    formData.candidateName &&
    formData.gender &&
    formData.mobileNo &&
    formData.email &&
    formData.dateOfBirth &&
    formData.country &&
    formData.state &&
    formData.city &&
    formData.address &&
    formData.nationality &&
    formData.course
  ) {
    // Mark the token as used
    let tokens = {};
    const storedTokens = localStorage.getItem('registrationTokens');
    if (storedTokens && storedTokens !== 'undefined') {
      try {
        tokens = JSON.parse(storedTokens);
      } catch (err) {
        console.warn('Invalid registrationTokens in localStorage:', err, storedTokens);
      }
    }
    if (tokens[token]) {
      tokens[token].used = true;
      localStorage.setItem('registrationTokens', JSON.stringify(tokens));
    }

    alert('Registration submitted successfully!');
  } else {
    alert('Please fill all required fields');
  }
};


  return (
    <Container maxWidth="sm">
     {!isTokenValid ? (
      <Box sx={{ mt: 4, p: 3, boxShadow: 3, borderRadius: 2, textAlign: 'center' }}>
        <Typography variant="h5" color="error" sx={{ mb: 2 }}>
          This link has already been used or is invalid.
        </Typography>
      </Box>
    ) :  
    
    ( <Box sx={{ mt: 4, p: 3, boxShadow: 3, borderRadius: 2 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Registration Form
        </Typography>
        <FormControlLabel
          control={<Checkbox name="sendSMS" checked={formData.sendSMS} onChange={handleChange} />}
          label="Send SMS"
          sx={{ mb: 2 }}
        />
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            label="Registration Code"
            variant="outlined"
            fullWidth
            name="registrationCode"
            value={formData.registrationCode}
            onChange={handleChange}
            required
          />
          <TextField
            label="Registration Date"
            type="date"
            variant="outlined"
            fullWidth
            name="registrationDate"
            value={formData.registrationDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Box>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            label="Candidate Name"
            variant="outlined"
            fullWidth
            name="candidateName"
            value={formData.candidateName}
            onChange={handleChange}
            required
          />
          <FormControl fullWidth required>
            <InputLabel>Gender</InputLabel>
            <Select
              name="gender"
              value={formData.gender}
              label="Gender"
              onChange={handleChange}
            >
              {staticGenderData.map((gender) => (
                <MenuItem key={gender.id} value={gender.name}>
                  {gender.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            label="Mobile No."
            variant="outlined"
            fullWidth
            name="mobileNo"
            value={formData.mobileNo}
            onChange={handleChange}
            required
          />
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Box>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            label="Date of Birth"
            type="date"
            variant="outlined"
            fullWidth
            name="dateOfBirth"
            value={formData.dateOfBirth}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            required
          />
          <FormControl fullWidth required>
            <InputLabel>Country</InputLabel>
            <Select
              name="country"
              value={formData.country}
              label="Country"
              onChange={handleChange}
            >
              {staticCountryData.map((country) => (
                <MenuItem key={country.id} value={country.name}>
                  {country.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <FormControl fullWidth required>
            <InputLabel>State</InputLabel>
            <Select
              name="state"
              value={formData.state}
              label="State"
              onChange={handleChange}
            >
              {staticStateData.map((state) => (
                <MenuItem key={state.id} value={state.name}>
                  {state.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth required>
            <InputLabel>City</InputLabel>
            <Select
              name="city"
              value={formData.city}
              label="City"
              onChange={handleChange}
            >
              {staticCityData.map((city) => (
                <MenuItem key={city.id} value={city.name}>
                  {city.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            label="Address"
            variant="outlined"
            fullWidth
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
          />
          <FormControl fullWidth required>
            <InputLabel>Nationality</InputLabel>
            <Select
              name="nationality"
              value={formData.nationality}
              label="Nationality"
              onChange={handleChange}
            >
              {staticNationalityData.map((nationality) => (
                <MenuItem key={nationality.id} value={nationality.name}>
                  {nationality.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            label="Registration Fee"
            variant="outlined"
            fullWidth
            name="registrationFee"
            value={formData.registrationFee}
            onChange={handleChange}
            type="number"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">₹</InputAdornment>
              ),
            }}
          />
          <FormControl fullWidth required>
            <InputLabel>Course</InputLabel>
            <Select
              name="course"
              value={formData.course}
              label="Course"
              onChange={handleChange}
            >
              {staticCourseData.map((course) => (
                <MenuItem key={course.id} value={course.name}>
                  {course.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{ mt: 2 }}
        >
          Submit
        </Button>
      </Box>)}
    </Container>
  );
};

export default ShareRegistrationPage;
